module.exports = __webpack_public_path__ + "img/google.157a7333.svg";